import React from 'react'
import PropTypes from 'prop-types'
import { launcherOpenUrl } from '../imports'

const renderers = {
    // We assume the first element in the markdown is the header
    // and that the rest is the EULA itself. So we split it up
    // and style it accordingly
    root(props) {
        const arr = props.className.split('|')
        const [title, ...text] = props.children
        return (
            <React.Fragment>
                <div className={arr[0]}>{title}</div>
                <div className={arr[1]}>
                    {text}
                </div>
            </React.Fragment>
        )
    },

    // We take the link from the markdown and change it
    // We want to disable the onClick function since we are going to
    // send a command with the url to the launcher backend instead of
    // opening the link ourselves
    link({ href, title, children }) {
        const settings = {
            href,
            title,
            onClick: (e) => {
                e.preventDefault()
                launcherOpenUrl(href)
            },
        }
        return <a {...settings}>{children}</a>
    },
}

renderers.link.propTypes = {
    href: PropTypes.string,
    title: PropTypes.string,
    children: PropTypes.node,
}

renderers.root.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
}

export default renderers



// WEBPACK FOOTER //
// ./src/features/Eula/markdown/customRenderers.js